// returns a concatenation of the amount + the noun indicating 0 (plural), 1 (singular) or multiple (plural)
// eslint-disable-next-line @typescript-eslint/default-param-last
const pluralise = (amount = Number.POSITIVE_INFINITY, singular, plural) => {
	if (amount === 1) return `${amount} ${singular}`;

	return `${amount} ${plural}`;
};

export default pluralise;
